var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "f7e931e06cf8ecd53461bc1eac00941616ad0686"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["launchpad@printdeal"] = {
  id: "f7e931e06cf8ecd53461bc1eac00941616ad0686"
};